export const NAME = "targetablePlaceSearch";
